module.exports = __webpack_public_path__ + "static/img/1.1aedef4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/servicios/1.png
// module id = B7fC
// module chunks = 0